import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { ToggleButton } from '../../../index';
import { GuestSelectorComponentProps } from '../sharedTypes';

export const ToggleGuestExtra: FC<GuestSelectorComponentProps> = ({ input, options = [] }) => {
  const { t } = useTranslations();
  const { value, onChange } = input;

  return (
    <ToggleButton
      onClick={() => onChange(value ? '' : [options[0]])}
      isSelected={!!value}
      selectedText={t('spa.extrasSelectedCTA')}
      type="button"
      inverted
    >
      {t('spa.extrasSelectCTA')}
    </ToggleButton>
  );
};
